import { css } from 'lit';
export default css `

  .mailing-list {
    padding-left: 10px;
    padding-right: 10px;
  }

  .mailing-list-header {
    font-size: 0.7rem;
    display: block;
    margin-bottom: 5px;
  }
  
  .mailing-list-promise {
    font-size: 0.7rem;
    display: block;
    margin-bottom: 5px;
    margin-top: 10px;
  }

  .error-input::part(base) {
    border-color: var(--error-color);
  }

  .error-input::part(input) {
    color: var(--error-color);
  }

  sl-button {
    margin-top: 10px;
  }

  .mailing-list-error {
    display: none;
    padding: 3px;
    margin-top: 10px;
    font-size: 0.8rem;
    border: 1px solid var(--error-color);
    color: var(--error-color);
    overflow-wrap: break-word;
    
  }
  
  
  .unsubscribed {
    display: block; 
  }
  
  .subscribed {
    display: none;
    border: 1px solid var(--terminal-text);
    padding: 5px;
    font-size: 0.7rem;
    word-break-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .subscribed header {
    font-size: 0.8rem;
    margin-bottom: 2px;
  } 
  
  .subscribed strong {
    color: var(--terminal-text);
  }
  
  .error-title {
    font-family: var(--font-stack-bold), monospace;
    text-decoration: underline;
  }

  .show {
    display: block;
  }

  .hide {
    display: none;
  }
  
  #email-input::part(base) {
    border-radius: 0;
  }
  #email-input::part(input) {
    font-size: 0.8rem;
    font-family: var(--font-stack), monospace;
    border-radius: 0;
  }
  
  #email-submit::part(base) {
    background-color: var(--background-color);
    border: 1px solid var(--primary-color);
    color: var(--primary-color);
    font-family: var(--font-stack), monospace;
    border-radius: 0;

  }
  

`;
